export const CATEGORIES = {
  EMPLOYER_HIRING_EVENT: 'EMPLOYER_HIRING_EVENT',
};

export const EMPLOYER_HIRING_EVENT_TYPES = [
  'HIRING_EVENT_APPROVED_EMPLOYER',
  'HIRING_EVENT_CANCELED_EMPLOYER',
  'HIRING_EVENT_PENDING_EMPLOYER',
  'HIRING_EVENT_REJECTED_EMPLOYER',
];

export const NOTIFICATION_TITLE_REGEX = /(<([^>]+)>)/ig;

export default {
  CATEGORIES,
  NOTIFICATION_TITLE_REGEX,
  EMPLOYER_HIRING_EVENT_TYPES,
};
